import React from "react";
import { Welcome }  from "screens/home/welcome/Welcome";

export const LandingLayout: React.FC = () => {

    return (
      <Welcome/>
    )
}